import React from "react";
import { FiHome } from "react-icons/fi";
import NotificationBadge from "../../style/NotificationBadge";
import { useNetwork } from "../NetworkProvider";

const ClientChatPreview = ({
    client,
    handleClientClick,
    notifications,
    selectedClient,
}) => {
    const { getMessagesNotifications } = useNetwork();
    const handleClick = (clientId) => {
        handleClientClick(clientId);
        getMessagesNotifications(clientId);
    };
    return (
        <li
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
            }}
            onClick={() => handleClick(client.client_id)}
            className={`${
                selectedClient === client.client_id ? "bg-gray-100" : "bg-white"
            } border-b border-gray-300 pr-3 hover:bg-gray-50`}
        >
            <div className="flex items-center w-full h-full group">
                <div
                    className={`${
                        selectedClient === client.client_id
                            ? "bg-black"
                            : "font-normal"
                    } rounded-full w-[3px] h-[80px] flex justify-center items-center`}
                />

                <NotificationBadge
                    notifications={
                        notifications.length
                            ? notifications.filter(
                                  (n) => n.client_id === client.client_id
                              )
                            : []
                    }
                    type="chat"
                >
                    <div
                        className={`${
                            selectedClient === client.client_id
                                ? "bg-gray-300"
                                : "bg-gray-100"
                        } rounded-full w-[50px] h-[50px] flex justify-center items-center ml-2`}
                    >
                        <FiHome color="white" />
                    </div>
                </NotificationBadge>
                <div className="ml-2 text-left flex-1">
                    <div
                        className={`text-base w-full flex justify-between group-hover:font-semibold gap-6  ${
                            selectedClient === client.client_id
                                ? "font-bold"
                                : "font-normal"
                        }`}
                    >
                        <span className="w-4/5 md:text-md">
                            {client.client_name}{" "}
                        </span>
                        <span className="text-gray-500 text-xs text-left w-1/5 ">
                            {" "}
                            ID: {client.client_id}
                        </span>
                    </div>
                    <div className="text-gray-500 text-sm italic">
                        {client.city}
                    </div>
                </div>
            </div>
        </li>
    );
};

export default ClientChatPreview;
